import { SvgIcon, type SvgIconProps, useTheme } from "@mui/material";

// Active-state AI glyph: white body with eyes in the active nav purple, so
// they read as cut-outs on the highlighted sidebar item.
export const HelenaAgentFilledIcon = (props: SvgIconProps) => {
  const theme = useTheme();
  const eyeColor = theme.palette.purple.main;

  return (
    <SvgIcon {...props}>
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.1992 2.99951C20.465 2.99953 20.5825 3.33438 20.375 3.50049L18.0635 5.34814C19.868 6.99404 20.9999 9.36464 21 11.9995C21 16.9701 16.9706 20.9985 12 20.9985L12.001 20.9995H3.80273C3.53689 20.9995 3.41936 20.6646 3.62695 20.4985L5.93652 18.6499C4.13246 17.004 3 14.634 3 11.9995C3.0001 7.02911 7.02961 2.99964 12 2.99951H20.1992Z"
          fill={theme.palette.neutral.main}
        />
        <circle cx="15" cy="12" r="1.5" fill={eyeColor} />
        <circle cx="9" cy="12" r="1.5" fill={eyeColor} />
      </svg>
    </SvgIcon>
  );
};
